interface FilterGroupProps {
  label: string;
  options: (string | number)[];
  selected: string[];
  onToggle: (value: string) => void;
}

export default function FilterGroup({ label, options, selected, onToggle }: FilterGroupProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4 py-3 border-b border-background-200 last:border-b-0">
      <span className="text-sm font-medium text-foreground-600 md:w-16 shrink-0 md:pt-1.5">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const value = String(option);
          const active = selected.includes(value);
          return (
            <button
              key={value}
              type="button"
              onClick={() => onToggle(value)}
              className={`px-3 py-1.5 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                active
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              {value}
            </button>
          );
        })}
      </div>
    </div>
  );
}